// extracted by mini-css-extract-plugin
module.exports = {"instagramWrapper":"nk-z","innerTile":"ok-z","heading":"pk-z","instaTileBtn":"qk-z","disabled":"rk-z","instaTileElement":"sk-z","instagramPic":"tk-z"};